const main = 'us-contracts'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
  relativeListWithTabAndSelected: 'tab-:activeTab/:selected',
}

const routes = {
  List: `/${main}`,
  ListWithTabAndSelected: `/${main}/${relativeRoutes.relativeListWithTabAndSelected}`,
}

const UsContractsRoutes = { ...relativeRoutes, ...routes }

export default UsContractsRoutes
